export const LOAD_SERVICE_PROVIDERS = `LOAD_SERVICE_PROVIDERS`;
export const LOAD_SERVICE_PROVIDERS_START = `${LOAD_SERVICE_PROVIDERS}_START`;
export const LOAD_SERVICE_PROVIDERS_SUCCESS = `${LOAD_SERVICE_PROVIDERS}_SUCCESS`;
export const LOAD_SERVICE_PROVIDERS_FAIL = `${LOAD_SERVICE_PROVIDERS}_FAIL`;

export const getServiceProviders = deviceType => {
  const params = {
    ...(deviceType && { deviceType }),
  };

  return {
    type: LOAD_SERVICE_PROVIDERS,
    meta: {
      xmApi: true,
      method: 'getall',
      uri: '/webapi/xm/1/service-providers',
      params,
    },
  };
};
